import { __assign, __rest } from "tslib";
import { classNamesFunction, DirectionalHint, IconButton, KeyCodes, ScreenWidthMinXLarge } from '@fluentui/react';
import { Nav } from '@m365-admin/nav';
import React from 'react';
var navCollapseButtonId = 'navCollapseButton';
var mobileNavOpenButtonId = 'mobileNavOpenButton';
var getClassNames = classNamesFunction();
var coherenceNavBase = function (props) {
    var _a, _b;
    var styles = props.styles, theme = props.theme, appName = props.appName, toggleNavAriaLabel = props.toggleNavAriaLabel, toggleNavTooltip = props.toggleNavTooltip, navProps = __rest(props, ["styles", "theme", "appName", "toggleNavAriaLabel", "toggleNavTooltip"]);
    var _c = React.useState(true), navIsHiddenOnMobile = _c[0], setNavIsHiddenOnMobile = _c[1];
    var _d = React.useState(true), isMobile = _d[0], setIsMobile = _d[1];
    var _e = React.useState(!!props.defaultIsNavCollapsed), isCoherenceNavCollapsed = _e[0], setIsCoherenceNavCollapsed = _e[1];
    var navWrapperRef = React.useRef(null);
    var mobileNavButtonRef = React.useRef(null);
    var frameIdRef = React.useRef(0);
    var hamburgerIcon = {
        iconName: 'GlobalNavButton'
    };
    var isNavCollapsed = navIsHiddenOnMobile === false ? false : isCoherenceNavCollapsed;
    var classNames = getClassNames(styles, {
        isNavCollapsed: isNavCollapsed,
        theme: theme,
        shouldScroll: false,
        zoomLevel: window.devicePixelRatio
    });
    React.useEffect(function () {
        var windowWidth = window.innerWidth;
        if (windowWidth < ScreenWidthMinXLarge && navProps.onNavCollapsed) {
            navProps.onNavCollapsed(true);
        }
        window.addEventListener('click', outSideClickDismiss);
        window.addEventListener('keydown', keydownDismiss);
        return function () {
            window.removeEventListener('click', outSideClickDismiss);
            window.removeEventListener('keydown', keydownDismiss);
        };
    }, []);
    React.useEffect(function () {
        window.removeEventListener('resize', handleResize);
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [isCoherenceNavCollapsed]);
    var handleResize = function () {
        if (frameIdRef.current !== 0) {
            cancelAnimationFrame(frameIdRef.current);
        }
        frameIdRef.current = requestAnimationFrame(shouldNavCollapse);
    };
    React.useEffect(function () {
        var _a, _b;
        var windowWidth = window.innerWidth;
        if (windowWidth < ScreenWidthMinXLarge && navIsHiddenOnMobile) {
            (_a = document.getElementById(mobileNavOpenButtonId)) === null || _a === void 0 ? void 0 : _a.focus();
        }
        if (windowWidth < ScreenWidthMinXLarge && !navIsHiddenOnMobile) {
            (_b = document.getElementById(navCollapseButtonId)) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [navIsHiddenOnMobile]);
    var outSideClickDismiss = function (event) {
        if (navWrapperRef.current &&
            !navWrapperRef.current.contains(event.target) &&
            mobileNavButtonRef.current &&
            !mobileNavButtonRef.current.contains(event.target)) {
            setNavIsHiddenOnMobile(true);
        }
    };
    var keydownDismiss = function (event) {
        if (event.keyCode === KeyCodes.escape || event.keyCode === KeyCodes.tab) {
            setNavIsHiddenOnMobile(true);
        }
    };
    var showMobileNav = function () {
        setNavIsHiddenOnMobile(false);
        setIsCoherenceNavCollapsed(false);
        if (navProps.onNavCollapsed) {
            navProps.onNavCollapsed(false);
        }
    };
    var navCollapseLinkClick = function (event) {
        var _a;
        setNavIsHiddenOnMobile(true);
        if ((_a = navProps.collapseNavLinkProps) === null || _a === void 0 ? void 0 : _a.onClick) {
            navProps.collapseNavLinkProps.onClick(event);
        }
    };
    var handleNavCollapsed = function () {
        if (window.innerWidth > ScreenWidthMinXLarge) {
            setIsCoherenceNavCollapsed(!isCoherenceNavCollapsed);
        }
        if (navProps.onNavCollapsed) {
            navProps.onNavCollapsed(!isCoherenceNavCollapsed);
        }
    };
    var shouldNavCollapse = function () {
        var _a, _b, _c;
        if (window.innerWidth < ScreenWidthMinXLarge) {
            if (!isCoherenceNavCollapsed) {
                (_a = navProps.onNavCollapsed) === null || _a === void 0 ? void 0 : _a.call(navProps, true);
            }
            setIsMobile(true);
            setIsCoherenceNavCollapsed(true);
        }
        else if (window.innerWidth >= ScreenWidthMinXLarge) {
            if (isMobile) {
                setIsMobile(false);
                setNavIsHiddenOnMobile(true);
                (_b = navProps.onNavCollapsed) === null || _b === void 0 ? void 0 : _b.call(navProps, false);
            }
            else if (isCoherenceNavCollapsed) {
                (_c = navProps.onNavCollapsed) === null || _c === void 0 ? void 0 : _c.call(navProps, false);
            }
            setIsCoherenceNavCollapsed(false);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames.mobileNavWrapper, ref: mobileNavButtonRef },
            React.createElement(IconButton, { iconProps: hamburgerIcon, className: classNames.mobileNavTrigger, onClick: showMobileNav, "aria-label": toggleNavAriaLabel !== null && toggleNavAriaLabel !== void 0 ? toggleNavAriaLabel : appName + " Navigation", "aria-expanded": !navIsHiddenOnMobile, id: mobileNavOpenButtonId })),
        React.createElement("div", { ref: navWrapperRef, className: classNames.outerNavWrapper + " " + (navIsHiddenOnMobile ? '' : classNames.showNav) },
            React.createElement(Nav, __assign({}, navProps, { collapseNavLinkProps: __assign({ title: undefined, onClick: navCollapseLinkClick, id: navCollapseButtonId, 'aria-label': toggleNavAriaLabel !== null && toggleNavAriaLabel !== void 0 ? toggleNavAriaLabel : appName + " Navigation", tooltipProps: { directionalHint: DirectionalHint.bottomLeftEdge, content: isNavCollapsed ? ((_a = toggleNavTooltip === null || toggleNavTooltip === void 0 ? void 0 : toggleNavTooltip.expand) !== null && _a !== void 0 ? _a : 'Expand navigation') : ((_b = toggleNavTooltip === null || toggleNavTooltip === void 0 ? void 0 : toggleNavTooltip.collapse) !== null && _b !== void 0 ? _b : 'Collapse navigation') } }, navProps.collapseNavLinkProps), isNavCollapsed: isNavCollapsed, onNavCollapsed: handleNavCollapsed, styles: {
                    root: classNames.root,
                    navContainer: classNames.navContainer,
                    navWrapper: classNames.navWrapper,
                    navGroup: classNames.navGroup,
                    navGroupDivider: classNames.navGroupDivider
                } })))));
};
export { coherenceNavBase as CoherenceNavBase };
//# sourceMappingURL=CoherenceNav.base.js.map